import type { EditorModel } from 'types/core';
import type { FedopsLogger } from 'types/fedops';
import type { StartupConfig } from '../common';
import { EditorBootstrapError, EditorBootstrapErrorCode } from '../errors';
import { loadPolyfills } from './loadPolyfills';

export async function loadMainPackages(
  {
    fedopsLogger,
  }: {
    fedopsLogger: FedopsLogger;
    editorModel: EditorModel;
  },
  _config: StartupConfig,
) {
  fedopsLogger.appLoadingPhaseStart('main-chunk-load-main-packages');

  await loadPolyfills();

  fedopsLogger.appLoadingPhaseStart('main-chunk-load-rEditor');
  const rEditor = await import('@/rEditor', {
    with: { preload: 'true' },
  }).catch((error) => {
    console.error(error);
    throw new EditorBootstrapError('Failed to load @/rEditor', {
      code: EditorBootstrapErrorCode.LoadPackagesError,
      originalError: error,
    });
  });
  fedopsLogger.appLoadingPhaseFinish('main-chunk-load-rEditor');

  fedopsLogger.appLoadingPhaseFinish('main-chunk-load-main-packages');

  if (typeof window.__editorMainJsLoadedCb === 'function') {
    window.__editorMainJsLoadedCb();
  }

  return {
    rEditor,
  };
}
